module.exports = __webpack_public_path__ + "static/media/kordrengir.a0fde849.svg";